<div class="number-stats-n-pat" [ngStyle]="containerStyle">
  <ng-container *ngIf="!hasError; else errorState">
    <div class="stats-grid" [ngStyle]="gridStyle">
      <article
        class="stat-card"
        *ngFor="let card of cards; trackBy: trackByCard"
        [ngClass]="card.statusClass"
        [ngStyle]="card.cardStyle"
      >
        <div class="card-header">
          <div class="card-title" [ngStyle]="card.titleStyle">{{ card.title }}</div>
          <div
            *ngIf="card.icon"
            class="card-icon"
            [ngClass]="card.statusClass"
            [ngStyle]="card.iconStyle"
          >
            <mat-icon *ngIf="card.iconType === 'mat'; else textIcon">{{ card.icon }}</mat-icon>
            <ng-template #textIcon>
              <span>{{ card.icon }}</span>
            </ng-template>
          </div>
        </div>

        <ng-container *ngIf="card.rows.length > 0; else singleValue">
          <div class="stat-rows">
            <div
              class="stat-row"
              *ngFor="let row of card.rows; trackBy: trackByRow"
              [ngStyle]="row.rowStyle"
            >
              <span class="row-label" [ngStyle]="row.labelStyle">{{ row.label }}</span>
              <span class="row-value" [ngStyle]="row.valueStyle">{{ row.value }}</span>
            </div>
          </div>
        </ng-container>

        <ng-template #singleValue>
          <div class="value-line">
            <span class="card-value" [ngStyle]="card.valueStyle">{{ card.value }}</span>
          </div>
        </ng-template>
      </article>
    </div>
  </ng-container>

  <ng-template #errorState>
    <div class="stats-error">
      <mat-icon>{{ errorIcon || 'error_outline' }}</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  </ng-template>
</div>
